import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseWork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSuitcaseWork"><Path fillRule="evenodd" clipRule="evenodd" d="M9.5 3C8.67157 3 8 3.67157 8 4.5V6H16V4.5C16 3.67157 15.3284 3 14.5 3H9.5ZM17 6V4.5C17 3.11929 15.8807 2 14.5 2H9.5C8.11929 2 7 3.11929 7 4.5V6H4.5C3.11929 6 2 7.11929 2 8.5V18.5C2 19.8807 3.11929 21 4.5 21H19.5C20.8807 21 22 19.8807 22 18.5V8.5C22 7.11929 20.8807 6 19.5 6H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSuitcaseWork;
